module.exports = __webpack_public_path__ + "918b699874fd8f6b3a627ef3c00d9bb6.svg";